import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentArrowUpFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.667.5C12.667.5 14 1.864 14 5.954V15.5H2V.5zM4.504 7.501l.99.99 1.804-1.804v4.977h1.4V6.687l1.804 1.803.99-.989-3.494-3.494z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
DocumentArrowUpFilledSize16Glyph.displayName = 'DocumentArrowUpFilledSize16Glyph';
